module.exports = __webpack_public_path__ + "img/R8803-ST.622a3ad6.jpg";